<div class="table-header d-flex justify-content-between">
    <h2 class="p-4 m-0">
        <mat-icon class="scale-2 mr-3">{{icon}}</mat-icon> {{name}}
    </h2>
    <ng-content select="[buttons]"></ng-content>
</div>